/**
 * URLs das imagens do guia "API de Envio (Envios V2 - ÁtomosChat)".
 * Defina VITE_GUIDE_IMAGES_BASE_URL (URL base até public/guides, com barra no final)
 * após rodar o upload: cd backend && npm run upload:guide-images
 */
const BASE =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_GUIDE_IMAGES_BASE_URL) || '';

const SLUG = 'atomos-chat-api-envio';

export const ATOMOS_CHAT_GUIDE_IMAGES: Record<string, string> = {
  step1: BASE ? `${BASE.replace(/\/$/, '')}/${SLUG}/step1.png` : '',
  step2: BASE ? `${BASE.replace(/\/$/, '')}/${SLUG}/step2.png` : '',
  step3: BASE ? `${BASE.replace(/\/$/, '')}/${SLUG}/step3.png` : '',
  step4: BASE ? `${BASE.replace(/\/$/, '')}/${SLUG}/step4.png` : '',
  step5: BASE ? `${BASE.replace(/\/$/, '')}/${SLUG}/step5.png` : '',
};
